/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
import 'reflect-metadata';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';

if (environment.production && environment.environment !== 'production' && environment.environment !== 'prod') {
  enableProdMode();
  Sentry.init({
    environment: environment.environment,
    release: 'tineon-verein-cloud@' + environment.version,
    dsn: 'https://94c838562ad6140dd91c1c1d2b302cf6@o889147.ingest.sentry.io/4506490067156992',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration({
        beforeStartSpan: (context) => {
          return {
            ...context,
            name: location.pathname.replace(/\/[a-f0-9]{32}/g, '/<hash>').replace(/\/\d+/g, '/<digits>'),
          };
        },
        instrumentNavigation: true,
      }),

      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.environment === 'production' ? 0.1 : 1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [environment.apiUrl, /^\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
